import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing a filter view for reversion reload.
 * @extends JetView
 */
export default class FilterReversionReloadView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing Recharge Number input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RechargeNumber', // Name of the input field
                    label: _('Nro. Recarga:'), // Label for the input field
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Nro. Recarga'), // Placeholder text
                },
            ],
        };

        // Center left section containing Client Number input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'ClientNumber', // Name of the input field
                    label: _('Nro. Cliente:'), // Label for the input field
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Nro. Cliente'), // Placeholder text
                },
            ],
        };

        // Center right section containing Customer Name input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'CustomerName', // Name of the input field
                    label: _('Nombre Cliente:'), // Label for the input field
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Nombre Cliente'), // Placeholder text
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the three input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive behavior
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Data object for displaying values (not used in the UI directly)
        const datos = {
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        // Button section with Clear and Consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form', // Button type
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get values from the form
                        this.app.callEvent('reversionReload:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                Email: webix.rules.isEmail, // Validation rule for email
            },
        };
    }
}

// FILE DOCUMENTED
